import { Search } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import Footer from '../components/landing/Footer';
import Nav from '../components/landing/Nav';
import hero from '../images/products-hero.png';

const categories = ['Marketplace', 'Featured', 'Newly Launched', 'Expiring Soon', 'Coming Soon'];
const dealType = ['Lifetime', 'Annual', 'Freebie'];
const sortBy = ['Price: high to low', 'Price: low to high', 'Latest'];

export default function Products() {
  return (
    <>
      <Nav />
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography mt={{ xs: 2, md: 6 }} variant="h1">
              Get Access To Our Exclusive Lifetime Deals
            </Typography>
            <br />
            <Typography variant="h4">Never pay full price for software again. Get up to 95% discount.</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={hero} alt="hero" />
          </Grid>
        </Grid>
        <Divider sx={{ my: 4 }} />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <FormControl fullWidth sx={{ m: 1 }} variant="standard">
            <InputLabel htmlFor="standard-adornment-search">Search</InputLabel>
            <Input
              id="standard-adornment-search"
              startAdornment={
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="categories-select-label">Categories</InputLabel>
            <Select labelId="categories-select-label" id="categories-simple-select" label="Categories">
              {categories.map((e) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="dealtype-select-label">Deal Type</InputLabel>
            <Select labelId="dealtype-select-label" id="dealtype-select" label="Deal Type">
              {dealType.map((e) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="sort-select-label">Sort by</InputLabel>
            <Select labelId="sort-select-label" id="sort-select" label="Sort by">
              {sortBy.map((e) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        <Grid mt={4} container spacing={4}>
          {new Array(5).fill(0).map((e, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <CategoryCard />
            </Grid>
          ))}
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

const CategoryCard = () => (
  <Card rounded>
    <img src="https://picsum.photos/200" width="100%" height="200" alt="category" />
    <Box p={2}>
      <Typography variant="h4">Ruttl</Typography>
      <Typography>Collect Comments & Design Feedback on Live Websites & Make Real-Time Edits!</Typography>
      <br />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <div>
          <Stack direction="row" alignItems="end">
            <Typography variant="h4">
              49
            </Typography>
            <Typography>/lifetime</Typography>
          </Stack>
        </div>
        <Button size="small" variant="outlined">
          Learn More
        </Button>
      </Stack>
    </Box>
  </Card>
);
